import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import Onboarding2022App from 'bundles/onboarding-2022/components/Onboarding2022App';
import NotFound from 'bundles/phoenix/components/NotFound';

const OnboardingPage = loadOnRoute(() => import('bundles/onboarding-2022/components/OnboardingPage'));

export default (
  <Route path="/" component={Onboarding2022App}>
    <Route path="onboarding-2022/:questionId" getComponent={OnboardingPage} />
    <Route path="onboarding-2022" getComponent={OnboardingPage} />
    <Route path="onboarding/:questionId" getComponent={OnboardingPage} />
    <Route path="onboarding" getComponent={OnboardingPage} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
